module.exports = __webpack_public_path__ + "media/images/countrysquared/ke-936f2931e4b7ff8462301311c8992de0.svg";